import React from 'react';
import CalendarWeekBarLayout from './CalendarWeekBarLayout';
import CalendarWeekDay from './CalendarWeekDay';
export default function CalendarWeekBar() {
    return (React.createElement(CalendarWeekBarLayout, null,
        React.createElement(CalendarWeekDay, null, "\u65E5"),
        React.createElement(CalendarWeekDay, null, "\u4E00"),
        React.createElement(CalendarWeekDay, null, "\u4E8C"),
        React.createElement(CalendarWeekDay, null, "\u4E09"),
        React.createElement(CalendarWeekDay, null, "\u56DB"),
        React.createElement(CalendarWeekDay, null, "\u4E94"),
        React.createElement(CalendarWeekDay, null, "\u516D")));
}
//# sourceMappingURL=CalendarWeekBar.js.map